var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4305_2713)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 56,
    r: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 56,
    r: 47.5,
    stroke: "#337FE0",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7293 55.2C63.1293 55.4333 64.346 55.9667 65.3793 56.8C66.446 57.6 67.2626 58.6333 67.8293 59.9C68.396 61.1333 68.6793 62.5333 68.6793 64.1C68.6793 66.1667 68.1626 67.9667 67.1293 69.5C66.1293 71.0333 64.696 72.2167 62.8293 73.05C60.9626 73.9167 58.7626 74.35 56.2293 74.35C53.696 74.35 51.4626 73.9 49.5293 73C47.596 72.1333 46.046 70.8667 44.8793 69.2L48.2293 65.4C49.0293 66.6 50.0626 67.55 51.3293 68.25C52.596 68.9833 54.196 69.35 56.1293 69.35C58.296 69.35 59.9793 68.8833 61.1793 67.95C62.3793 67.0167 62.9793 65.6167 62.9793 63.75C62.9793 61.8167 62.3126 60.3 60.9793 59.2C59.6793 58.1 57.7126 57.55 55.0793 57.55H53.7293V53.25H55.2293C57.4626 53.25 59.1793 52.7333 60.3793 51.7C61.5793 50.6333 62.1793 49.3 62.1793 47.7C62.1793 46.6333 61.9293 45.7667 61.4293 45.1C60.9626 44.4 60.296 43.8833 59.4293 43.55C58.5626 43.2167 57.5626 43.05 56.4293 43.05C54.7293 43.05 53.2293 43.4167 51.9293 44.15C50.6293 44.8833 49.596 45.9333 48.8293 47.3L45.3793 43.55C46.046 42.4833 46.9626 41.55 48.1293 40.75C49.296 39.95 50.6293 39.3333 52.1293 38.9C53.6626 38.4333 55.2793 38.2 56.9793 38.2C59.1793 38.2 61.1126 38.5667 62.7793 39.3C64.446 40.0333 65.7293 41.0667 66.6293 42.4C67.5626 43.7333 68.0293 45.3 68.0293 47.1C68.0293 48.4 67.7793 49.6333 67.2793 50.8C66.7793 51.9333 66.046 52.9 65.0793 53.7C64.1126 54.4667 62.996 54.9667 61.7293 55.2Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4305_2713",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4305_2713"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4305_2713",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.b0ac77083f01674ceb1cae2ff9b2e9d3.svg";
export { ForwardRef as ReactComponent };